import { Carousel } from 'antd';
import React, { useEffect } from 'react';
import { apiClient } from '../../api';
import BritzLogo from "../../img/britz_logo.svg";
import "./Banner.scoped.scss";

const Banner = ({ page }) => {
  const env = 'ants1' //Banner env : For support each site (different banner image)
  const [bannerList, setBannerList] = React.useState([])

  const onChange = currentSlide => {
    console.log(currentSlide);
  };

  const getBannerList = async () => {
    try {
      await apiClient.get(`api/ecom/banner-list/${env}`)
        .then(result => {
          setBannerList(result.data)
        })
        .catch(error => {
          console.log(error)
        })
    }
    catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getBannerList()
  }, [])

  return (
    <div className="banner-card">
      {/* <img src={BritzLogo} alt="Britz Logo" className="britz-logo" /> */}
      <Carousel afterChange={onChange} draggable={true}>
        {bannerList?.map((x, index) => (
          <div
            key={x.index}
            className='banner-item'
          >
            <img
              src={`data:${x.contentType};base64,${x.fileBase64}`}
              alt={`Banner ${x.index}`}
            />
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default Banner